import type { Theme } from '@mui/material';

export const gameNamesWrapperSx = { rowGap: 6.5, columnGap: 6 };
export const getGameNameButtonSx = (theme: Theme, isFirst: boolean) => ({
  color: theme.palette.dark,
  height: isFirst ? 160 : 156,
  width: isFirst ? '100%' : 'calc(50% - 13px)',
});
export const getAmountButtonSx = (theme: Theme, isLast:boolean) => ({
  color: theme.palette.dark,
  py: isLast ? 3 : 10,
  px: 6,
  flex: '0 0 calc((100% - 2 * 24px) / 3)', // 2 gaps * 24px
});
export const imgSx = { width: 200, height: 200 };